import { Button, Typography } from 'gu-ui-kit'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'

const Recover = () => {
  const { t } = useTranslation()
  const { email } = useParams()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::recover_sent.title')}</title>
      </Helmet>
      <Typography
        className={'margin-bottom-16'}
        component={'h1'}
        variant={'Body-Accent-40'}
        color={'Label-Fifth'}
      >
        {t('auth::recover_sent.title')}
      </Typography>

      <Typography
        className={'margin-bottom-40'}
        variant={'Body-Accent-20'}
        color={'Label-Fifth'}
        component={'p'}
      >
        {t('auth::recover_sent.full_text', { email })}
      </Typography>
      <Button
        variant={'secondary'}
        fullWidth
        onClick={() =>
          history.push(pathGen(ROUTES.AUTH_RECOVER_WITH_EMAIL, { email }))
        }
      >
        {t('auth::recover_sent.button')}
      </Button>
    </>
  )
}

export default Recover
